<script setup>
    definePageMeta({
        layout: 'home',
        scrollToTop: false,
    })
    
    useHead({
        title: 'younovate.au - Novated leasing',
    })
</script>

<template>
    <div>
        <QuoteBuilderStep1 />
    </div>
</template>
